import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'toastr/build/toastr.css';
import './index.css';
import * as _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import { LicenseManager } from '@ag-grid-enterprise/core';

import AppWithAuth from './AppWithAuth';
import history from './history';

const { REACT_APP_SENTRY_DSN: SENTRY_DSN } = process.env;
const { REACT_APP_ENVIRONMENT: ENVIRONMENT } = process.env;

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: `admin-ui@${process.env.REACT_APP_VERSION}`,
    autoSessionTracking: false,
    beforeSend(event, hint) {
      if (hint && !(hint.originalException instanceof Error)) {
        _.set(event, 'extra.meta', JSON.stringify(hint.originalException));
        if (hint.originalException.data || hint.originalException.errors) {
          _.set(event, 'exception.values[0].type', 'Joyn2Error');
          _.set(event, 'exception.values[0].type', 'GraphQLError');
          event.fingerprint = ['GraphQLError'];
          if (!event.message || !hint.originalException.message) {
            _.set(event, 'message', 'GraphQLError');
          }
        } else if (hint.originalException.message) {
          _.set(event, 'exception.values[0].type', 'Joyn2Error');
          event.fingerprint = ['Joyn2Error'];
        }
      }
      const { syntheticException } = hint || {};
      if (!event.fingerprint && syntheticException && syntheticException.message) {
        event.fingerprint = ['syntheticException'];
        _.set(event, 'extra.meta', JSON.stringify(hint.originalException));
        if (!event.message) {
          _.set(event, 'message', syntheticException.message);
        }
      }
      return event;
    },
  });
}
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-107779}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{W_Energy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Joyn}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Joyn}_need_to_be_licensed___{Joyn}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_November_2026}____[v3]_[01]_MTc5NDYxNDQwMDAwMA==4d4afe55050db6a10a44d091808a329d'
);

// eslint-disable-next-line react/jsx-filename-extension
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppWithAuth history={history} />);
